import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

import { AuthService } from '../../../services/auth.service';

import { User, UserType } from '../../../models/User.model';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.less']
})
export class NavmenuComponent implements OnInit {

    constructor(
        private _auth: AuthService,
        private _router: Router
    ) { }

    private user: User;
    userType = UserType;
    show = false;

    toggleCollapse(): void {
        this.show = !this.show;
    }

    logout(): void {
        this.toggleCollapse();
        sessionStorage.setItem('loggingOut', 'true');
        this._auth.logout();
        this._router.navigate(['/login']);
    }

    ngOnInit() {
        this.user = this._auth.getUser();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/navmenu/navmenu.component.ts